import { createContext } from 'react';

import type { SourceFetch } from '../data-source';

/** Troca o `fetch` das fontes numa subárvore. Só a prévia de dev (`preview.tsx`) usa; produção não tem provider. */
export const SourceFetchContext = createContext<SourceFetch | null>(null);
